


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class OverlappingPanel extends Vue {
  @Prop({ required: true })
  panelId: string;

  @Prop({ default: 'left' })
  slidingDirection: 'left' | 'right' | 'top' | 'bottom';

  @Prop({ required: true })
  collapsed: boolean;

  get transitionName() {
    return `ebx-overlapping-panel--${ this.slidingDirection }`;
  }

  mounted() {
    this.$x.emit(EVENTS.QuantumEntanglement, this.panelId);
  }
}
